import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Spinner from "../../../../reusableComponents/Spinner";
import { getPayoutSplitList } from "../../../../store/reducers/accountSlice";
import { returnErrors } from "../../../../store/reducers/error";
import { returnMessages } from "../../../../store/reducers/message";
import { paymentMethods, payoutRequest } from "../../../../utils/apis/payment";
import "./style.scss";

import RecipientBankDetails from "../../RecipientBankDetails";
import edit from "../../../../assets/icons/edit-pencil copy.svg";
import LoaderOverlay from "../../../../reusableComponents/Loader";
import { newCryptoSelectorStyles, newSelectorStyles } from "../../../../customstyle/customstyle";
import InvoiceDetails from "../../../FundingEvaluation/PaymentModule/InvoiceDetails";
import { Modal } from "antd";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";
import TadaSound from "../../../../assets/SoundFiles/tada-fanfare-a-6313.mp3";

function PayoutSplit() {
  const { width, height } = useWindowSize();
  const [showConfetti, setShowConfetti] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    audioRef.current = new Audio(TadaSound);
  }, []);

  const idToken = useSelector((state) => state.auth.idToken);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  const dispatch = useDispatch();
  const payoutPfs = useSelector((state) => state.account.payoutListPFS);

  const [accountListValue, setAccountListValue] = useState(payoutPfs?.data);
  useEffect(() => {
    setAccountListValue(payoutPfs?.data);
  }, [payoutPfs?.data]);

  useEffect(() => {
    dispatch(getPayoutSplitList({ idToken, selectedBrand }));
  }, [idToken]);

  const [restrictAllPayout, setRestrictAllPayout] = useState(false);
  const [isRestrictModalVisible, setIsRestrictModalVisible] = useState(false);

  console.log(accountListValue, "accountListValueaccountListValue");
  const [accountList, setAccountList] = useState(
    accountListValue?.data?.map((obj) => ({
      value: obj.account,
      label: obj.account,
      amount: obj.payable_amt,
    })),
  );

  useEffect(() => {
    const filteredList = accountListValue?.data?.map((obj) => ({
      value: obj.account,
      label: obj.account,
      amount: obj.payable_amt,
    }));
    setAccountList(filteredList);
  }, [idToken, accountListValue]);
  const [payout, setPayout] = useState({
    amount_requested: "",
    reason: "",
    login_id: null,
    payout_type: "PFS",
    method: "",
  });

  const [maxAmount, setMaxAmount] = useState(0);

  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      setPayout({ ...payout, login_id: selectedOption.value, amount_requested: selectedOption.amount });
    }
    setMaxAmount(selectedOption.amount);
  };

  const handleSelectMethod = (selectedOption) => {
    if (selectedOption.value === "CRYPTO_BEP20") {
      setPayout({ ...payout, method: "CRYPTO", crypto_type: "USDT BEP-20" });
      setValue(7);
    } else if (selectedOption.value === "CRYPTO_ERC20") {
      setPayout({ ...payout, method: "CRYPTO", crypto_type: "USDT ERC-20" });
      setValue(6);
    } else {
      setPayout({ ...payout, method: selectedOption.value });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (e.target.type === "number") {
      setPayout({ ...payout, [name]: Number(value) });
    } else {
      setPayout({ ...payout, [name]: value });
    }
  };
  const formData = new FormData();
  for (const key in payout) {
    formData.append(key, payout[key]);
  }

  const [successmodalOpen, setSuccessModalOpen] = useState(false);
  const [errormodalOpen, setErrorModalOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [isSpinner, setIsSpinner] = useState(false);

  const options = accountList;

  const methodOptions = [
    {
      label: (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span>WIRE</span>
          <img
            src={edit}
            alt=""
            style={{ marginLeft: "15px" }}
            onClick={(e) => {
              e.stopPropagation();
              setValue(3);
            }}
          />
        </div>
      ),
      value: "SWIFT",
    },
    {
      label: (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span>USDT BEP-20 (Binance Smart Chain)</span>{" "}
          <img
            src={edit}
            alt=""
            style={{ marginLeft: "15px" }}
            onClick={(e) => {
              e.stopPropagation();
              setValue(7);
            }}
          />
        </div>
      ),
      value: "CRYPTO_BEP20",
    },
    {
      label: (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span>USDT ERC-20 (Ethereum)</span>{" "}
          <img
            src={edit}
            alt=""
            style={{ marginLeft: "15px" }}
            onClick={(e) => {
              e.stopPropagation();
              setValue(6);
            }}
          />
        </div>
      ),
      value: "CRYPTO_ERC20",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const data = useSelector((state) => state.account.accountList);

  let filter = null;

  let meta = null;

  if (Array.isArray(data?.data)) {
    for (const item of data.data) {
      if (item?.login_id === payout?.login_id) {
        filter = item;
        meta = item;
        break;
      }
    }
  } else {
    // Handle the case where data?.data is not an array
    console.warn("No data found to iterate over");
  }

  let nextPayout = false;

  const isOnDemand = meta?.meta?.addon?.title !== "On Demand Payout" && nextPayout === true;

  console.log("metametameta", nextPayout, isOnDemand);

  if (filter && isOnDemand) {
    const currentDateTime = new Date();
    const currentDate = currentDateTime.toISOString().split("T")[0]; // Get today's date in "YYYY-MM-DD" format
    nextPayout = filter.next_payout_date > currentDate;
  }

  const isActive = data && data?.data?.filter((item) => item?.is_active === true);
  const phase = data && data?.data?.filter((item) => item?.phase === "funded");

  const [refreshBanksDetails, setRefreshBanksDetails] = useState(false);

  const [paymentDetails, setPaymentdetails] = useState([]);
  const fetchPaymentdetails = async () => {
    const respo = await paymentMethods(idToken, dispatch);
    setPaymentdetails(respo);
  };
  useEffect(() => {
    fetchPaymentdetails();
  }, [refreshBanksDetails]);
  const closeBankDetailsModal = (clearMethod = false) => {
    setValue(false);
    if (clearMethod) {
      setPayout((prev) => ({
        ...prev,
        method: null,
        crypto_type: null,
      }));
    }
  };
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (payout?.method === "SWIFT") {
      setValue(3);
    } else if (payout?.method === "CRYPTO" && payout?.crypto_type === "USDT BEP-20") {
      setValue(7); // BEP modal
    } else if (payout?.method === "CRYPTO") {
      setValue(6); // ERC modal
    }
  }, [payout?.method, payout?.crypto_type]);

  const handleSubmit = async () => {
    // Prevent double-submit
    // if (restrictAllPayout && selectedBrand?.brand === "equity_edge") {
    //   setIsRestrictModalVisible(true);
    //   return;
    // }

    // Now lock further requests
    // setRestrictAllPayout(true);

    setIsSpinner(true);
    const response = await payoutRequest(idToken, formData, selectedBrand);

    setMsg(response.status || response.message);

    if (response.status === 200 || response.status === 201) {
      setShowConfetti(true);
      if (audioRef.current) {
        audioRef.current.play().catch((e) => console.error("Audio play failed:", e));
      }
      setTimeout(() => setShowConfetti(false), 8000);

      // setSuccessModalOpen(true);
      dispatch(returnMessages("Payout Successful", 200));
      // Reset form inputs after successful submit
      setPayout({
        amount_requested: "",
        reason: "",
        login_id: null,
        payout_type: "PFS",
        method: "",
        crypto_type: "",
      });
      dispatch(getPayoutSplitList({ idToken, selectedBrand }));
      setMaxAmount(0);
      setValue(null);
      setIsSpinner(false);
    } else {
      dispatch(returnErrors(response?.response?.data?.detail || response?.response?.data?.amount[0] || "Something went wrong", 400));
      setIsSpinner(false);
    }
  };
  const [timeLeft, setTimeLeft] = useState(null);
  const intervalRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => {
        const now = new Date();
        const expiration = new Date(filter?.next_payout_date);
        const difference = expiration - now;

        if (difference <= 0) {
          clearInterval(intervalRef.current);
          setTimeLeft("Expired");
        } else {
          const days = Math.floor(difference / (1000 * 60 * 60 * 24));
          const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((difference / 1000 / 60) % 60);
          // const seconds = Math.floor((difference / 1000) % 60);
          //${seconds}s

          !isNaN(days) && setTimeLeft(`${days}days ${hours}hrs ${minutes}min`);
          !isNaN(days) && setIsLoading(false);
        }
      }, 1000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [filter?.next_payout_date]);
  const [selectedAddress, setSelectedAddress] = useState(0);
  console.log(isSpinner, !payout.method, !payout.login_id, nextPayout, isOnDemand, "isSpinner || !payout.method || !payout.login_id || nextPayout || isOnDemand");
  return (
    <>
      {showConfetti && (
        <Confetti
          width={width}
          height={height}
          recycle={false}
          numberOfPieces={350}
          gravity={0.9}
          colors={["#36d66b", "#071e0d", "#ffffff", "#ffb100"]}
          style={{ position: "fixed", top: 0, left: 0, zIndex: 999999 }}
        />
      )}
      {isLoading && nextPayout && <LoaderOverlay />}

      <div className="reqpayout">
        <RecipientBankDetails
          refreshBanksDetails={refreshBanksDetails}
          setRefreshBanksDetails={setRefreshBanksDetails}
          value={value}
          setValue={setValue}
          closeBankDetailsModal={closeBankDetailsModal}
        />
        {/* <Modal
          title="Action Blocked"
          visible={isRestrictModalVisible}
          onOk={() => setIsRestrictModalVisible(false)}
          onCancel={() => setIsRestrictModalVisible(false)}
          okText="OK"
          cancelButtonProps={{style: {display: "none"}}}
          className="payoutRestrictModal"
        >
          <p className="payoutModalText">Payout requests are temporarily disabled from 24 to 31 July due to a critical system upgrade ahead of our MT5 launch.</p>
          <br />
          <p className="payoutModalText">
            If you were eligible for a payout during this period, you’ll receive a free MT5 2-Step EE $5K Challenge with your next payout request by opening a support ticket.
          </p>
        </Modal> */}
        <div className="req_payout_wrapper">
          <p className="note">{isActive?.length > 0 && phase?.length > 0 ? "You can only request a payout here on the 14th day since your first trade" : ""}</p>
          <div className="col1">
            <div className="select_container_L">
              <div className="col1_lower_select_container">
                <p className="header_of_input">Choose Account Login ID</p>
                <Select
                  className="withdrawalSelectors"
                  placeholder="Select"
                  classNamePrefix="react-select"
                  options={options}
                  styles={selectedBrand?.brand === "equity_edge" ? newSelectorStyles(50) : selectedBrand?.brand === "crypto_edge" ? newCryptoSelectorStyles(50) : newSelectorStyles(50)}
                  name="login_id"
                  value={options?.find((option) => option.value === payout.login_id) || null}
                  onChange={handleSelectChange}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  isSearchable={false}
                />
                {isOnDemand && nextPayout && timeLeft && <p className="remaining_days_note">Remaining days for next payout :- {timeLeft}.</p>}
              </div>
              <div className="col1_lower_select_container">
                <p className="header_of_input">Choose Payout Method</p>
                <Select
                  className="withdrawalSelectors"
                  placeholder="Select"
                  classNamePrefix="react-select"
                  options={methodOptions}
                  styles={selectedBrand?.brand === "equity_edge" ? newSelectorStyles(50) : selectedBrand?.brand === "crypto_edge" ? newCryptoSelectorStyles(50) : newSelectorStyles(50)}
                  name="method"
                  value={
                    methodOptions?.find((option) => {
                      if (payout.method === "CRYPTO" && payout.crypto_type === "USDT BEP-20") {
                        return option.value === "CRYPTO_BEP20";
                      } else if (payout.method === "CRYPTO" && payout.crypto_type === "USDT ERC-20") {
                        return option.value === "CRYPTO_ERC20";
                      }
                      return option.value === payout.method;
                    }) || null
                  }
                  onChange={handleSelectMethod}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  isSearchable={false}
                />
              </div>
              <div
                style={{ width: "100%" }}
                className="col1_lower_select_container amountBtn"
              >
                <p className="header_of_input">Amount ($)</p>
                <div className="input_section_button">
                  <input
                    type="number"
                    name="amount_requested"
                    value={(payout.amount_requested > maxAmount ? maxAmount : payout.amount_requested) || ""}
                    onChange={handleInputChange}
                    placeholder="Amount"
                    disabled={payout.amount_requested}
                    className="withdrawalInput"
                  />
                  <button
                    className="maxBtn"
                    onClick={() => setPayout({ ...payout, amount_requested: maxAmount })}
                  >
                    Max
                  </button>
                </div>
              </div>
            </div>
            <div className="col1_button">
              <button
                onClick={handleSubmit}
                disabled={isSpinner || !payout.method || !payout.login_id || nextPayout || isOnDemand}
                style={isSpinner || !payout.method || !payout.login_id || nextPayout ? { backgroundColor: "#d3d3d3", cursor: "not-allowed" } : {}}
              >
                {isSpinner ? <Spinner /> : <>Submit</>}
              </button>
            </div>
          </div>
        </div>{" "}
        {/* <div className="addressBox">
          <InvoiceDetails
            selectedAddress={selectedAddress}
            setSelectedAddress={setSelectedAddress}
            variant={2}
          />
        </div> */}
      </div>
    </>
  );
}

export default PayoutSplit;
